"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.previousView = previousView;
var _changeView = require("./changeView");
function previousView() {
  return (dispatch, getState, context) => {
    const {
      logger
    } = context;
    const {
      view: {
        data
      }
    } = getState();
    if (!data || !data.prevView) {
      logger.warning('Failed to switch previous view');
      return;
    }
    dispatch((0, _changeView.changeView)(data.prevView, data.prevData));
  };
}